import React from 'react';

import { AccountDisplayProps } from '../AccountPanel';
import { EditProfile } from './EditProfile';

export const SettingEditProfile: React.FC<AccountDisplayProps> = ({
	popDisplayState,
}) => {
	return <EditProfile onSave={popDisplayState} />;
};
